<template>
    <div class="content">
        <div class="get-box">
            <img src="../../assets/images/personal/step3_get.png" alt="">
            <p>恭喜你获得个人挑战答题赛**奖</p>
        </div>
         <div class="no-get-box">
            <img src="../../assets/images/personal/step3_no_get.png" alt="">
            <p>很遗憾您未获奖…</p>
        </div>
    </div>
</template>

<script>
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  mounted () {
  },
}
</script> 

<style scoped>
    .content{
        height: 500px;
        text-align: center;
        font-size: 18px;
    }
   img{
        margin: 10px 0 30px;
        height: 252px;
        width: 252px;
    }
    .get-box p{
        color: #733085;
    }
    .get-box{
        display: none;
    } 
    .no-get-box p{
        color: #444444;
    }
</style>
